import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";
import Logo from "../../images/logo.png";

const SmsTemplatePreview = ({ showModal, setShowModal, content }) => {
  return (
    <>
      {showModal && (
        <Transition.Root show={showModal} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => setShowModal(false)}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-center justify-center text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-[10px] bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-[910px] py-6 md:py-8 block mx-3 max-h-[calc(100vh-40px)] h-full">
                    <div className="">
                      <div className="border-b border-solid border-[#EBEFF3] text-center pb-6 mb-5 px-10">
                        <Link to="/">
                          <img src={Logo} alt="" className="h-[34px]" />
                        </Link>
                      </div>
                      <div className="overflow-scroll max-h-[calc(100vh-200px)] px-10">
                        <pre
                          className="whitespace-pre-wrap"
                          style={{
                            wordWrap: "break-word",
                            fontFamily: "Satoshi",
                          }}
                        >
                          {content}
                        </pre>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </>
  );
};

export default SmsTemplatePreview;
